<template>
    <footer class="bg-third text-white py-3">
        <div class="container">
            <span>
                &copy; Copyright {{ year }} - Autoguidovie spa
            </span>
            <br>
            <small>
                Capitale Sociale € 30.000.000,00 i.v. - REA Milano n. 103484 - P. Iva 11907120155 - CF. e Registro Imprese di Milano n. 00103400339
            </small>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
    name: 'FooterComp',
    computed: {
        ...mapGetters(['omsApiKey'])
    },
    data() {
        return {
            year: moment().year()
        }
    }
}
</script>